export default [
  {
    path: "/checkGoodsApply",
    name: "checkGoodsApply",
    meta: {
      name: "checkGoodsApply",
      title: "验货申请详情"
    },
    component: resolve =>
      require(["@/components/detail/checkGoodsApply"], resolve)
  },
  {
    path: "/billApplyDetail",
    name: "billApplyDetail",
    meta: {
      requireAuth: true,
      name: "billApplyDetail",
      title: "对账单号",
      parentTitle: "财务",
      parentName: "finance"
    },
    component: resolve =>
      require(["@/components/detail/billApplyDetail"], resolve)
  },
  {
    path: "/applyDetail",
    name: "applyDetail",
    meta: {
      requireAuth: true,
      name: "applyDetail",
      title: "验货单号",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve => require(["@/components/detail/applyDetail"], resolve)
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    meta: {
      requireAuth: true,
      name: "orderDetail",
      title: "采购凭证号",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve => require(["@/pages/order/orderList/detail"], resolve)
  },
  {
    path: "/orderListRawDetail",
    name: "orderListRawDetail",
    meta: {
      requireAuth: true,
      name: "orderListRawDetail",
      title: "采购订单（原材料）",
      parentTitle: "采购订单（原材料）",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/orderListRaw/detail"], resolve)
  },
  {
    path: "/inspectionReport",
    name: "inspectionReport",
    meta: {
      requireAuth: true,
      name: "inspectionReport",
      title: "质检报告",
      parentTitle: "质检报告",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/orderListRaw/inspectionReport"], resolve)
  },
  {
    path: "/tailoringPackDetail",
    name: "tailoringPackDetail",
    meta: {
      requireAuth: true,
      name: "tailoringPackDetail",
      title: "成衣装箱单",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/components/detail/tailoringPackDetail"], resolve)
  },
  {
    path: "/tailoringScanEncasement",
    name: "tailoringScanEncasement",
    meta: {
      requireAuth: true,
      name: "tailoringScanEncasement",
      title: "扫描装箱",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/components/detail/tailoringScanEncasement"], resolve)
  },
  {
    path: "/tailoringScanEncasementRFID",
    name: "tailoringScanEncasementRFID",
    meta: {
      requireAuth: true,
      name: "tailoringScanEncasementRFID",
      title: "扫描装箱RFID",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/components/detail/tailoringScanEncasementRFID"], resolve)
  },
  {
    path: "/orderProgressFinishDetail",
    name: "orderProgressFinishDetail",
    meta: {
      requireAuth: true,
      name: "orderProgressFinishDetail",
      title: "采购进度（成品）详情",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/OrderProgressFinish/detail"], resolve)
  },
  {
    path: "/orderProgressMaterialDetail",
    name: "orderProgressMaterialDetail",
    meta: {
      requireAuth: true,
      name: "orderProgressMaterialDetail",
      title: "采购进度（原材料）详情",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/OrderProgressMaterial/detail"], resolve)
  },
  {
    path: "/messageDetail",
    name: "messageDetail",
    meta: {
      requireAuth: true,
      name: "messageDetail",
      title: "公告消息详情",
      parentTitle: "消息管理",
      parentName: "informationManagement"
    },
    component: resolve =>
      require(["@/pages/informationManagement/notice/detail"], resolve)
  },
  {
    path: "/barcodeApplicationDetail",
    name: "barcodeApplicationDetail",
    meta: {
      requireAuth: true,
      name: "barcodeApplicationDetail",
      title: "条码申请详情",
      parentTitle: "查看条码申请",
      parentName: "barcodeApplication"
    },
    component: resolve =>
      require(["@/pages/materialManagement/barcodeApplication/detail"], resolve)
  },
  {
    path: "/barcodeReturnDetail",
    name: "barcodeReturnDetail",
    meta: {
      requireAuth: true,
      name: "barcodeReturnDetail",
      title: "条码退料详情",
      parentTitle: "查看条码退料",
      parentName: "barcodeReturn"
    },
    component: resolve =>
      require(["@/pages/materialManagement/barcodeReturn/detail"], resolve)
  },
  {
    path: "/orderBarcodeApplicationDetail",
    name: "orderBarcodeApplicationDetail",
    meta: {
      requireAuth: true,
      name: "orderBarcodeApplicationDetail",
      title: "申请条码",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/orderList/detail/barcodeApplication"], resolve)
  },
  {
    path: "/orderBarcodeReturnDetail",
    name: "orderBarcodeReturnDetail",
    meta: {
      requireAuth: true,
      name: "orderBarcodeReturnDetail",
      title: "条码退料",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/orderList/detail/barcodeReturn"], resolve)
  },
  {
    path: "/orderReplenishmentDetail",
    name: "orderReplenishmentDetail",
    meta: {
      requireAuth: true,
      name: "orderReplenishmentDetail",
      title: "补料申请",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/orderList/detail/replenishment/index"], resolve)
  },
  {
    path: "/orderReturnDetail",
    name: "orderReturnDetail",
    meta: {
      requireAuth: true,
      name: "orderReturnDetail",
      title: "退料申请",
      parentTitle: "订单",
      parentName: "order"
    },
    component: resolve =>
      require(["@/pages/order/orderList/detail/return/index"], resolve)
  },
  {
    path: "/blankDetail",
    name: "blankDetail",
    meta: {
      requireAuth: true,
      name: "blankDetail",
      title: "备坯备料详情",
      parentTitle: "查看备坯备料",
      parentName: "blank"
    },
    component: resolve =>
      require(["@/pages/materialManagement/blank/detail"], resolve)
  },
  {
    path: "/fileListDetail",
    name: "fileListDetail",
    meta: {
      requireAuth: true,
      name: "fileListDetail",
      title: "文件管理详情",
      parentTitle: "文件管理列表",
      parentName: "fileList"
    },
    component: resolve =>
      require(["@/pages/fileManagement/fileList/detail"], resolve)
  },
  {
    path: "/externalCooperation/deliverListDetail",
    name: "deliverListDetail",
    meta: {
      requireAuth: true,
      name: "deliverListDetail",
      title: "外协发货单详情",
      parentTitle: "外协发货单",
      parentName: "deliverList"
    },
    component: resolve =>
      require([
        "@/pages/materialManagement/externalCooperation/deliverList/detail"
      ], resolve)
  },
  {
    path: "/externalCooperation/waitingListDetail",
    name: "waitingListDetail",
    meta: {
      requireAuth: true,
      name: "waitingListDetail",
      title: "外协待发货单详情",
      parentTitle: "外协待发货单",
      parentName: "waitingList"
    },
    component: resolve =>
      require([
        "@/pages/materialManagement/externalCooperation/waitingList/detail"
      ], resolve)
  },
  {
    path: "/externalCooperation/deliverListDetail",
    name: "deliverListDetail",
    meta: {
      requireAuth: true,
      name: "deliverListDetail",
      title: "外协发货单详情",
      parentTitle: "外协发货单",
      parentName: "deliverList"
    },
    component: resolve =>
      require([
        "@/pages/materialManagement/externalCooperation/deliverList/detail"
      ], resolve)
  },
  {
    path: "/externalCooperation/replenishmentApplyDetail",
    name: "replenishmentApplyDetail",
    meta: {
      requireAuth: true,
      name: "replenishmentApplyDetail",
      title: "补料申请详情",
      parentTitle: "补料申请",
      parentName: "replenishmentApply"
    },
    component: resolve =>
      require(["@/pages/materialManagement/replenishmentApply/detail"], resolve)
  },
  {
    path: "/externalCooperation/returnApplyDetail",
    name: "returnApplyDetail",
    meta: {
      requireAuth: true,
      name: "returnApplyDetail",
      title: "退料申请详情",
      parentTitle: "退料申请",
      parentName: "returnApply"
    },
    component: resolve =>
      require(["@/pages/materialManagement/returnApply/detail"], resolve)
  },
  {
    path: "/FabricDistributionDetail",
    name: "FabricDistributionDetail",
    meta: {
      requireAuth: true,
      name: "FabricDistributionDetail",
      title: "面料发料详情",
      parentTitle: "面料发料",
      parentName: "FabricDistribution"
    },
    component: resolve =>
      require(["@/pages/fabricSeasoning/FabricDistribution/detail"], resolve)
  },
  {
    path: "/FabricReconciliationDetail",
    name: "FabricReconciliationDetail",
    meta: {
      requireAuth: true,
      name: "FabricReconciliationDetail",
      title: "面料开发对账详情",
      parentTitle: "面料开发对账",
      parentName: "FabricReconciliation"
    },
    component: resolve =>
      require(["@/pages/fabricSeasoning/FabricReconciliation/detail"], resolve)
  },
  {
    path: "/PrepaymentTaxInvoiceDetail",
    name: "PrepaymentTaxInvoiceDetail",
    meta: {
      requireAuth: true,
      name: "PrepaymentTaxInvoiceDetail",
      title: "预付款税票详情",
      parentTitle: "预付款税票",
      parentName: "PrepaymentTaxInvoice"
    },
    component: resolve =>
      require(["@/pages/finance/PrepaymentTaxInvoice/detail"], resolve)
  },
  {
    path: "/ConsignmentSalesReconciliationDetail",
    name: "ConsignmentSalesReconciliationDetail",
    meta: {
      requireAuth: true,
      name: "ConsignmentSalesReconciliationDetail",
      title: "代销对账详情",
      parentTitle: "代销对账",
      parentName: "ConsignmentSalesReconciliation"
    },
    component: resolve =>
      require([
        "@/pages/finance/ConsignmentSalesReconciliation/detail"
      ], resolve)
  }
];



// WEBPACK FOOTER //
// ./src/router/details.js